export var CHANGE_SIDEBAR_WIDTH = '[LAYOUT SIDEBAR] WIDTH CHANGE';
export var changeLayoutSidebarWidht = function (width) { return function (dispatch) {
    return dispatch({
        type: CHANGE_SIDEBAR_WIDTH,
        payload: { width: width },
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/layoutSidebar.actions.ts
// module id = 603
// module chunks = 81